<template>
  <div class="menu">
    <div class="wrapper">
      <div class="container">
        <ul class="nav">
          <li class="nav__item">
            <router-link to="/products" class="title small">
              ITEMS
            </router-link>
          </li>

          <li v-if="$parent.isAuth" class="nav__item">
            <button
              type="button"
              class="title small sell-skins-btn"
              @click="openSellSkins"
            >
              SELL SKINS
            </button>
          </li>

          <li class="nav__item">
            <div class="title small" @click="scrollToSection('#how')">
              HOW TO JOIN
            </div>
          </li>
        </ul>

        <div v-if="$parent.isAuth" class="balance">
          <button type="button" class="button profile-button dark">
            <div class="balance-text">
              <span class="title small gray"> Balance: </span>

              <span class="title small amount">
                {{
                  Math.floor(Number($parent.profileData.balance || 0) * 100) /
                  100
                }}
                {{ $parent.currency }}
              </span>
            </div>

            <div class="button plus" @click="$parent.openTopUpModal">
              <img src="../images/plus.svg" class="img" alt="Top up" />
            </div>
          </button>
        </div>

        <router-link
          v-if="$parent.isAuth"
          to="/profile"
          class="button black"
          @click.native="$parent.closeMenu()"
        >
          My profile
        </router-link>

        <div
          v-if="!$parent.isAuth"
          class="button"
          @click="$parent.openSignInModal"
        >
          <span>LOGIN WITH STEAM</span>
        </div>

        <div
          v-if="curr && $parent.currencyOptions.length > 1"
          class="select-container"
        >
          <select
            v-model="curr"
            class="select currency-select"
            @change="selectCurr"
          >
            <option v-for="item in currOptions" :key="item" :value="item">
              {{ item }}
            </option>
          </select>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Menu',

  props: ['currency', 'currencyCode', 'currencyValue'],

  data() {
    return {
      topUpIsVisible: false,
      amount: 5,
      curr: '',
    }
  },

  computed: {
    currOptions() {
      return this.$parent.currencyOptions.map(({ code }) => code)
    },
  },

  watch: {
    currencyCode(newValue) {
      this.curr = newValue
    },
  },

  mounted() {
    this.curr = this.currencyCode
  },

  methods: {
    openSellSkins() {
      this.$emit('openSellSkins')
    },

    selectCurr() {
      this.changeCurrency(this.curr)
      localStorage.setItem('currency', this.curr)
    },

    changeCurrency(item) {
      this.$emit('changeCurrency', item)
    },

    scrollToSection(section) {
      this.$parent.closeMenu()
      this.$emit('scrollToSection', section)
    },

    decrease() {
      if (this.amount > 0) {
        this.amount -= 1
      } else {
        this.amount = 0
      }
    },

    increase() {
      this.amount += 1
    },

    toCheckout() {
      if (this.amount > 0) {
        this.topUpIsVisible = false

        this.$emit('setAmount', this.amount)

        this.$router.push({
          path: '/cart',
          query: {
            amount: this.amount,
          },
        })
      }
    },
  },
}
</script>

<style scoped>
.sell-skins-btn {
  background: transparent;
  border: none;
  padding: 0;
  margin: 0;
  color: inherit;
  font: inherit;
  cursor: pointer;
  text-align: inherit;
}

.sell-skins-btn:hover {
  opacity: 0.8;
}
</style>
